
export enum AnalyticsEvent {
  CLICK_ORDER_INFO_TAB = 'Order info tab clicked',
  CLICK_GALLERY_TAB = 'Gallery tab clicked',
  CLICK_GALLERY_STAGING = 'Gallery stage card clicked',
  CLICK_GALLERY_TAB_STAGE = 'Gallery stage tab clicked',
  CLICK_ORDER_DETAILS = 'See order details clicked',
  USE_GALLERY_FILTER = 'Gallery filter clicked',
  USE_COPY_LINK = 'Use Copy Link',
  GALLERY_PHOTO_FULL_PREVIEW = 'Full preview entered',
  CLICK_DOWNLOAD_VISUALS = 'Gallery floating bar download clicked',
  CLICK_EDIT_VISUALS = 'Gallery floating bar edit visuals clicked',
  CLICK_CONFIRM_VISUAL_SELECTION = 'Visual selection confirmed',
  GALLERY_SAAS_UPSELL_EDIT_VISUALS = 'Gallery saas upsell - edit visuals',
  GALLERY_SAAS_UPSELL_TEXT_GENERATOR = 'Gallery saas upsell - text generator',
  GALLERY_DOWNLOAD_TRIGGERED = 'download_triggered',
  GALLERY_MARK_FAVORITE = 'Gallery mark favorite',
  GALLERY_UNMARK_FAVORITE = 'Gallery unmark favorite',
  GALLERY_VIRTUAL_VISIT_OPEN_CSAT = 'Open gallery Virtual Visit CSAT',
  GALLERY_VIRTUAL_VISIT_CLOSE_CSAT = 'Close gallery Virtual Visit CSAT',
  GALLERY_FLOATING_BAR_EXPORT_OPTIONS = 'Gallery - floating bar export options',
  ACCEPT_INVITATION = 'Accept Invitation',
  CREATIVE_FIRST_TIME_DASHBOARD = 'creative_first_time_dashboard',
  CLIENT_FIRST_TIME_DASHBOARD = 'client_first_time_dashboard',
  UPLOAD_ERROR = 'Upload Error',
  ADMIN_DASHBOARD_ORDER_STATUS_SELECTION = 'OPS Filter - Status Tab',
  CREATIVE_DASHBOARD_ORDER_STATUS_SELECTION = 'CT Filter - Status Tab',
  CLIENT_DASHBOARD_ORDER_STATUS_SELECTION_ALL_VISUALS = 'All Visuals Filter - Status Tab',
  CLIENT_DASHBOARD_ORDER_STATUS_SELECTION_MY_VISUALS = 'My Visuals Filter - Status Tab',
  DASHBOARD_ORDER_DATE_SELECTION_ALL_VISUALS = 'All Visuals Filter - Date Tab',
  DASHBOARD_ORDER_DATE_SELECTION_MY_VISUALS = 'My Visuals Filter - Date Tab',
  ORDER_PURCHASED = 'Purchased',
  CLICK_SAVE_TEMPLATE = 'Click Save Template',
  CANCEL_DOWNLOAD_BULK_EDITING = 'Cancel Download Bulk Editing',
  WORKSPACE_PROFILE_MANAGE_BILLING = 'Manage Billing',
  WORKSPACE_DEEP_LINK_RESOLVED = 'workspace_deep_link_resolved',
  WORKSPACE_PROFILE_BILLING_PORTAL_OPENED = 'Billing Portal Opened',
  PURCHASE_FLOW_ENTERS_ORDER_BILLING_STEP = 'enters_order_billing_selection_screen',
  PURCHASE_FLOW_ENTERS_ORDER_INSTRUCTIONS_STEP = 'enters_order_instructions_selection_screen',
  PURCHASE_FLOW_ENTERS_ORDER_PRODUCTS_STEP = 'enters_order_products_selection_screen',
  PURCHASE_FLOW_ENTERS_ORDER_VALIDATION_STEP = 'enters_order_validation_screen',
  PURCHASE_FLOW_PURCHASE = 'Purchase',
  STAGING_OPEN_COMMENT_POPUP = 'Staging_open_comment_popup',
  STAGING_SAVE_COMMENT_POPUP = 'Staging_save_comment_popup',
  STAGING_EDIT_COMMENT_POPUP = 'Staging_edit_comment_popup',
  STAGING_REMOVE_COMMENT = 'Staging_remove_comment',
  CLOSE_PURCHASE_FLOW = 'Close_purchase_flow',
  PURCHASE_FLOW_CLICK_PREVIOUS_STEP = 'Clicks_previous_step_purchase_flow',
  PURCHASE_FLOW_CLICK_NEXT_STEP = 'Clicks_next_step_purchase_flow',
  PURCHASE_FLOW_SIZE_PROPERTY_SELECTED = 'Size_property_selected',
  PURCHASE_FLOW_OPTION_SELECTED = 'option_selected',
  PURCHASE_FLOW_OPTION_REMOVED = 'option_removed',
  PURCHASE_FLOW_FAST_DELIVERY_SELECTED = 'fast_delivery_selected',
  PURCHASE_FLOW_FAST_DELIVERY_REMOVED = 'fast_delivery_removed',
  PURCHASE_FLOW_I_ON_SITE_SELECTED = 'I_am_on_site_selected',
  PURCHASE_FLOW_PAYMENT_METHOD_SELECTED = 'Payment_method_selected',
  PURCHASE_FLOW_PAYMENT_METHOD_SAVED = 'Payment_method_saved_as_default',
  PURCHASE_FLOW_ORGANISATION_METHOD_SELECTED = 'organisation_method_selected',
  PURCHASE_FLOW_EMBED_REPRICED = 'embed_pricing_repriced',
  PURCHASE_FLOW_EMBED_CONSENT_RECORDED = 'embed_consent_recorded',
  PURCHASE_FLOW_EMBED_OVERLAY_SHOWN = 'embed_overlay_shown',
  PURCHASE_FLOW_EMBED_OVERLAY_SERVICE_SELECTED = 'embed_overlay_service_selected',
  PURCHASE_FLOW_EMBED_SIZE_GATE_BLOCKED = 'embed_size_gate_blocked',
  EMBED_STATUS_CARD_SHOWN = 'embed_status_card_shown',
  EMBED_STATUS_CARD_ACTION_CLICKED = 'embed_status_card_action_clicked',
  EMBED_STATUS_CARD_CANCEL_SUCCEEDED = 'embed_status_card_cancel_succeeded',
  EMBED_STATUS_CARD_CANCEL_OPENED = 'embed_status_card_cancel_opened',
  EMBED_STATUS_CARD_CANCEL_SUBMITTED = 'embed_status_card_cancel_submitted',
  EMBED_STATUS_CARD_CANCEL_ABANDONED = 'embed_status_card_cancel_abandoned',
  EMBED_STATUS_CARD_CANCEL_FAILED = 'embed_status_card_cancel_failed',
  RESCHEDULE_SUCCEEDED = 'reschedule_succeeded',
  RESCHEDULE_FAILED = 'reschedule_failed',
  EMBED_BLOCKED_PARENT_ORIGIN = 'embed_blocked_parent_origin',
  EMBED_ORDER_CONFIRMATION_SHOWN = 'embed_order_confirmation_shown',
  EMBED_ORDER_CONFIRMATION_CLOSE_CLICKED = 'embed_order_confirmation_close_clicked',
  EMBED_ORDER_CONFIRMATION_CLOSE_UNAVAILABLE = 'embed_order_confirmation_close_unavailable',
  /** The flow's own top-bar X inside the iframe — the broker abandoning an order in progress. */
  EMBED_FLOW_CLOSE_CLICKED = 'embed_flow_close_clicked',
  EMBED_FLOW_CLOSE_UNAVAILABLE = 'embed_flow_close_unavailable',
  EMBED_ORDER_CANCELLED_CLOSE_CLICKED = 'embed_order_cancelled_close_clicked',
  EMBED_ORDER_CANCELLED_CLOSE_UNAVAILABLE = 'embed_order_cancelled_close_unavailable',
  EMBED_COOKIE_DECLINED = 'embed_cookie_declined',
  ORDER_FLOW_LOADED = 'order_flow_loaded',
  ROOM_TYPE_SELECTED = 'Room_types_selected',
  ROOM_TYPE_SAVED = 'Room_types_saved',
  FURNITURE_FLOW_OPENED = 'Furniture_flow_opened',
  FURNITURE_FLOW_CLOSED = 'Furniture_flow_closed',
  FURNITURE_TEMPLATES_SELECTED = 'Furniture_templates_selected',
  FURNITURE_TEMPLATES_SAVED = 'Furniture_templates_saved',
  FURNITURE_TEMPLATES_FILTER = 'Furniture_templates_filter',
  FLOOR_FLOW_OPENED = 'Floor_flow_opened',
  FLOOR_FLOW_CLOSED = 'Floor_flow_closed',
  FLOOR_TEMPLATES_SELECTED = 'Floor_templates_selected',
  FLOOR_TEMPLATES_SAVED = 'Floor_templates_saved',
  DECORATION_FLOW_OPENED = 'Decoration_flow_opened',
  DECORATION_FLOW_CLOSED = 'Decoration_flow_closed',
  DECORATION_TEMPLATES_SELECTED = 'Decoration_templates_selected',
  DECORATION_TEMPLATES_SAVED = 'Decoration_templates_saved',
  WALL_FLOW_OPENED = 'Wall_flow_opened',
  WALL_FLOW_CLOSED = 'Wall_flow_closed',
  WALL_TEMPLATES_SELECTED = 'Wall_templates_selected',
  WALL_TEMPLATES_SAVED = 'Wall_templates_saved',
  REMOVED_OBJECT_TYPE = 'Removed_object_type',
  PROFOLIO_OPENED = 'Portfolio_opened',
  VISUAL_QUALITY_DECLINED = 'Visual_quality_declined',
  LET_BKBN_DECIDE_SELECTED = 'Let_bkbn_decide_selected',
  CUSTOMISE_MYSELF_SELECTED = 'Customise_myself_selected',
  CREATIVE_REMOVED_BY_ADMIN = 'creative_removed_by_admin',
  CREATIVE_SELECTED_BY_ADMIN = 'creative_selected_by_admin',
  CREATIVE_SELECTION_REFUSED_BY_ELIGIBILITY = 'creative_selection_refused_by_eligibility',
  CREATIVE_ONBOARDED_BY_ADMIN = 'onboard_creative',
  CLIENT_ONBOARDED_BY_ADMIN = 'onboard_client',
  GUIDELINES_DENIED = 'guidelines_denied',
  GUIDELINES_VALIDATED = 'guidelines_validated',
  GUIDELINES_OPENED = 'guidelines_opened',
  LIGHTROOM_GUIDE_OPENED = 'lightroom_guide_opened',
  LIGHTROOM_PLUGIN_DOWNLOADED = 'lightroom_plugin_downloaded',
  /**
   * A creative copied one of the client's instruction texts on the guidelines page (ISSUE-4076). Same name and
   * `kind` values as the creatives app; the web sends `surface: 'webGuidelines'` and the internal `assignmentId`,
   * because `/creative-instructions` carries no order id. Logged only once the clipboard write succeeded.
   */
  CREATIVE_INSTRUCTIONS_COPIED = 'copy_instructions',
  /**
   * Once per guidelines banner: whether the assignment's own comments ("Additional comments") were `shown`, cut
   * away as repeating the other texts (`covered`), `empty`, or not sent by the backend (`absent`). Never the text.
   */
  CREATIVE_INSTRUCTIONS_ADDITIONAL_COMMENTS = 'creative_instructions_additional_comments',
  CREATIVE_ACCEPTS_ASSIGNMENT = 'creative_accepts_assignment',
  CREATIVE_VISUALS_DELIVERY = 'creative_visuals_delivery',
  CREATIVE_SELECTED_BY_CLIENT = 'creative_selected_by_client',
  SELECT_CREATIVE_OPTION_OPENED = 'select_creative_option_opened',
  FAVOURITE_CREATIVES_UNAVAILABLE = 'favourite_creatives_unavailable',
  FLOOR_PLAN_COLOR_SELECTED = 'floor_plan_color_selected',
  FLOOR_PLAN_CREATE_SELECTED = 'floor_plan_create_selected',
  FLOOR_PLAN_LOGO_UPLOADED = 'floor_plan_logo_uploaded',
  FLOOR_PLAN_OPTIONS_SELECTED = 'floor_plan_options_selected',
  FLOOR_PLAN_TEMPLATE_SELECTED = 'floor_plan_template_selected',
  FLOOR_PLAN_TYPE_SELECTED = 'floor_plan_type_selected',
  FLOOR_PLANNER_LINK_CLICKED = 'Floorplan_self_editing_link_opened',
  CLICK_BACKBONE_LOGO = 'Click Backbone Logo',
  CLICK_MAIN_MENU = 'Click main menu',
  CLICK_ORDER_NEW_VISUALS = 'Click Order new visuals',
  CLICK_MAIN_MENU_DASHBOARD = 'Click main menu - Dashboard',
  CLICK_MAIN_MENU_LANGUAGE = 'Click main menu - Language',
  CLICK_MAIN_MENU_PROFILE = 'Click main menu - Profile',
  CLICK_MAIN_MENU_USER_PROFILE = 'Click main menu - User Profile',
  CLICK_MAIN_MENU_HELP_CENTER = 'Click main menu - Help Center',
  CLICK_MAIN_MENU_CONTACT_US = 'Click main menu - Contact Us',
  CLICK_MAIN_MENU_TERMS_AND_POLICY = 'Click main menu - Terms & Policy',
  CLICK_MAIN_MENU_ORDER_NEW_VISUALS = 'Click main menu - Order new visuals',
  CLICK_MAIN_MENU_SETTINGS = 'Click main menu - Settings',
  CLICK_MAIN_MENU_WORKSPACE_PROFILE = 'Click main menu - Workspace Profile',
  CLICK_MAIN_MENU_MEMBERS = 'Click main menu - Members',
  CLICK_MAIN_MENU_INTEGRATIONS = 'Click main menu - Integrations',
  CLICK_MAIN_MENU_BILLING = 'Click main menu - Billing',
  CLICK_MAIN_MENU_LOG_OUT = 'Click main menu - Log out',
  ENTER_ORDER_PROPERTY_INFO_PAGE_SCREEN = 'enters_order_property_information_page_screen',
  ENTER_ORDER_POA_PAGE_SCREEN = 'enters_order_power_attorney_page_screen',
  ENTER_ORDER_MEASUREMENTS_PAGE_SCREEN = 'enters_order_measurements_requirement_page_screen',
  ENTER_ORDER_LIVING_AREA_CALCULATION_PAGE_SCREEN = 'enters_order_living_area_calculation_requirement_page_screen',
  ENTER_ORDER_FLOOR_PLAN_PAGE_SCREEN = 'enters_order_floor_plan_requirement_page_screen',
  ENTER_ORDER_STAGING_PAGE_SCREEN = 'enters_order_staging_requirement_page_screen',
  ENTER_ORDER_CATEGORY_PAGE_SCREEN = 'enters_order_category_selection_screen',
  MEASUREMENTS_REQUIREMENT_SET_UP = 'measurements_requirement_set_up',
  LIVING_AREA_CALCULATION_REQUIREMENT_SET_UP = 'living_area_calculation_requirement_set_up',
  OPENS_BUILDING_LAYOUT = 'opens_building_layout',
  OPENS_CONSTRUCTION_METHOD = 'opens_construction_method',
  OPENS_VENTILATION_HEATING = 'opens_ventilation_heating',
  OPENS_ADDITIONAL_INFORMATION = 'opens_additional_information',
  OPENS_PROPERTY_INFORMATION = 'opens_property_information',
  OPENS_HEATING_SYSTEM = 'opens_heating_system',
  OPENS_CONSUMPTION_INFORMATION = 'opens_consumption_information',
  CC_EMAIL_ADDED = 'cc_email_added',
  CC_EMAIL_REMOVED = 'cc_email_removed',
  PHOTO_STUDIO_OPENED = 'photo_studio_opened',
  PHOTO_STUDIO_EXIT = 'photo_studio_exit',
  PINTURA_EXIT = 'close_pintura',
  PINTURA_OPEN = 'open_pintura',
  PINTURA_SAVE_IMAGE = 'pintura_visual_saved',
  PHOTO_STUDIO_SAVE_IMAGE = 'edited_visual_saved',
  PINTURA_UPSELL_NON_SUBSCRIBER_BUTTON = 'upsell_pintura',
  PINTURA_CLOSE_UPSELL_ON_GALLERY = 'close_upsell_widget_gallery',
  PINTURA_UNDO = 'pintura_visual_editing_back',
  PINTURA_REDO = 'pintura_visual_editing_forward',
  PINTURA_ZOOM_IN = 'pintura_zoom_in',
  PINTURA_ZOOM_OUT = 'pintura_zoom_out',
  PINTURA_PHOTO_STUDIO_UNDO = 'pintura_photo_studio_back',
  PINTURA_PHOTO_STUDIO_REDO = 'pintura_photo_studio_forward',
  PHOTO_STUDIO_REVERT_ALL_CHANGES = 'photo_studio_revert_all_changes',
  MANUAL_ADDRESS_SELECTED = 'manual_address_selected',
  MANUAL_ADDRESS_UNSELECTED = 'manual_address_unselected',
  CLICK_PROPERTY_VISUALS_GALLERY_TAB = 'property_visuals_gallery_tab_clicked',
  CLICK_PROPERTY_DOCUMENTS = 'property_documents_tab_clicked',
  CLICK_PROPERTY_AI_TEXT_GENERATOR_TAB = 'property_ai_text_generator_tab_clicked',
  CLICK_PROPERTY_ORDERS_TAB = 'property_orders_tab_clicked',
  CLICK_PROPERTY_INFORMATION_TAB = 'property_information_tab_clicked',
  CLICK_PROPERTY_MARKETING_CAMPAIGN_TAB = 'property_marketing_campaign_tab_clicked',
  CLICK_AI_EDITING_OPTIONS = 'AI_options_selected',
  PURCHASE_AI_VISUALS_IN_GALLERY = 'AI_visuals_purchased',
  OPEN_PROPERTY = 'open_property',
  OPEN_PROPERTY_DASHBOARD = 'open_property_dashboard',
  OPEN_ORDERS_DASHBOARD = 'open_orders_dashboard',
  FILTER_PROPERTY = 'filter_property',
  PROPERTY_DOWNLOAD_VISUALS = 'property_download_visuals',
  PROPERTY_ORDER_VISUALS_CLICKED = 'property_order_visuals_clicked',
  PROPERTY_ORDER_VISUALS_OVERVIEW_HEADER_CLICKED = 'property_order_visuals_overview_header_clicked',
  PROPERTY_DOWNLOAD_DOCUMENTS = 'property_download_documents',
  PROPERTY_INFORMATION_SAVED = 'property_information_saved',
  PROPERTY_ACTION_REQUIRED_CLICKED = 'property_action_required_clicked',
  INVOICE_DOWNLOADED = 'invoice_downloaded',
  SELF_UPLOAD_CLICK = 'click_upload_visuals',
  SELF_UPLOAD_NEXT_STEP = 'upload_visuals_next_step',
  SELF_UPLOAD_OPTIONS_SELECTED = 'Upload_options_selected',
  CLICK_CHANGE_REQUEST_SENT = 'change_request_sent',
  EDIT_LAND_REGISTER_SHEET_MANUALLY = 'edit_land_register_sheet_manually',
  PARCEL_SELECTED = 'parcel_selected',
  OPEN_ERASER = 'open_eraser',
  PHOTO_STUDIO_UNSUPPORTED_DEVICE_MODAL_OPENED = 'photo_studio_unsupported_device_modal_opened',
  CT_UPLOAD_V1_TIMED = 'creative_upload_v1_time',
  CT_UPLOAD_V2_TIMED = 'creative_upload_v2_time',
  GALLERY_UPLOAD_TIMED = 'gallery_upload_time', // Admin/creative gallery counterpart of CT_UPLOAD_V2_TIMED
  CT_UPLOAD_HYDRATED = 'creative_upload_hydrated', // One CT upload page seeding pass from the RAW listing, incl. how long its thumbnails took
  CREATIVE_GALLERY_UPLOAD_REDIRECT = 'creative_gallery_upload_redirect',
  PHOTO_STUDIO_VISUAL_STAGING_GENERATION_TYPE_CHANGED = 'photo_studio_visual_staging_generation_type_changed',
  PHOTO_STUDIO_VISUAL_STAGING_PROCESSING_MODE_CHANGED = 'photo_studio_visual_staging_processing_mode_changed',
  PHOTO_STUDIO_VISUAL_STAGING_ROOM_TYPE_CHANGED = 'photo_studio_visual_staging_room_type_changed',
  PHOTO_STUDIO_VISUAL_STAGING_STYLE_CHANGED = 'photo_studio_visual_staging_style_changed',
  PHOTO_STUDIO_VISUAL_STAGING_FLOOR_TOGGLE = 'photo_studio_visual_staging_floor_toggle',
  PHOTO_STUDIO_VISUAL_STAGING_DISCLAIMER_TOGGLE = 'photo_studio_visual_staging_disclaimer_toggle',
  PHOTO_STUDIO_DISCLAIMER_SAVED = 'photo_studio_disclaimer_saved',
  PHOTO_STUDIO_BRUSH_SIZE_CHANGED = 'photo_studio_brush_size_changed',
  PHOTO_STUDIO_CLEAR_MASK = 'photo_studio_clear_mask',
  PHOTO_STUDIO_UNDO = 'photo_studio_undo',
  PHOTO_STUDIO_REDO = 'photo_studio_redo',
  PHOTO_STUDIO_EDITION_GROUP_CLICKED = 'photo_studio_edition_group_clicked',
  PHOTO_STUDIO_EDITION_SELECTED = 'photo_studio_edition_selected',
  PHOTO_STUDIO_MASK_APPLIED = 'photo_studio_mask_applied',
  PHOTO_STUDIO_VISUAL_GENERATED = 'photo_studio_visual_generated',
  PHOTO_STUDIO_UNDO_REDO = 'photo_studio_undo_redo',
  PHOTO_STUDIO_CANCELLED = 'photo_studio_cancelled',
  PHOTO_STUDIO_SAAS_UPSELL = 'photo_studio_saas_upsell',
  PHOTO_STUDIO_ALL_FEATURES_VIEW_TOGGLED = 'photo_studio_all_features_view_toggled',
  WORKSPACE_DROPDOWN_OPENED = 'workspace_dropdown_opened',
  WORKSPACE_SWITCHED = 'workspace_switched',
  PROPSTACK_BANNER_DISMISSED = 'propstack_banner_dismissed',
  PROPSTACK_BANNER_RESTORED = 'propstack_banner_restored',
  PROPSTACK_BANNER_LEARN_MORE_CLICKED = 'propstack_banner_learn_more_clicked',
  PROPSTACK_BADGE_POPOVER_OPENED = 'propstack_badge_popover_opened',
  WORKSPACE_CREATION_INITIATED = 'workspace_creation_initiated',
  WORKSPACE_CREATED = 'workspace_created',
  WORKSPACE_INVITATION = 'workspace_invitation',
  STAR_RATING_OPENED = 'star_rating_opened',
  STAR_RATING_CLOSED = 'star_rating_closed',
  ASSIGNMENT_DETAIL_DRAWER_OPENED = 'assignment_detail_drawer_opened',
  ASSIGNMENT_DETAIL_DRAWER_CLOSED = 'assignment_detail_drawer_closed',
  ASSIGNMENT_DETAIL_DOWNLOAD_FILE = 'assignment_detail_download_uploaded_file',
  ASSIGNMENT_DETAIL_DOWNLOAD_VISUAL = 'assignment_detail_download_uploaded_visual',
  ASSIGNMENT_DETAIL_DOWNLOAD_BULK_STARTED = 'assignment_detail_download_bulk_started',
  ASSIGNMENT_DETAIL_DOWNLOAD_BULK_SUCCEEDED = 'assignment_detail_download_bulk_succeeded',
  ASSIGNMENT_DETAIL_DOWNLOAD_BULK_FAILED = 'assignment_detail_download_bulk_failed',
  BULK_DELETE_PROPERTIES = 'bulk_delete_properties',
  TRANSFER_PROPERTIES = 'transfer_properties',
  REASSIGN_BROKER = 'reassign_broker',
  CHAT_WIDGET_OPEN_CONVERSATION_RESTORE = 'chat_widget_open_conversation_restore',
  CHAT_WIDGET_NOTIFICATION_PERMISSION_ANSWERED = 'chat_widget_notification_permission_answered', // permission: granted | denied | default (prompt dismissed); source: launcher | send
  CHAT_WIDGET_NOTIFICATION_PERMISSION_STATE = 'chat_widget_notification_permission_state', // not prompted: permission granted | denied | unsupported; source: launcher | send
  CHAT_WIDGET_SEND_REJECTED_CONVERSATION_CLOSED = 'chat_widget_send_rejected_conversation_closed', // conversationType
  CHAT_WIDGET_NEW_CONVERSATION_FROM_CLOSED_THREAD = 'chat_widget_new_conversation_from_closed_thread', // conversationType
  CHAT_WIDGET_CONVERSATION_CLOSED = 'chat_widget_conversation_closed', // conversationType; source: header_menu | close_prompt | answer_feedback
  CHAT_WIDGET_SUPPORT_CLOSED_NOTICE_SHOWN = 'chat_widget_support_closed_notice_shown', // surface: composer | thread; conversationId; conversationType; withReopeningTime; once per conversation and closed period
  CHAT_WIDGET_ASSISTANT_WAIT_ENDED = 'chat_widget_assistant_wait_ended', // outcome: answered | agent_joined | timed_out; waitedMs; escalated
  CHAT_WIDGET_COMPOSER_OPENED = 'chat_widget_composer_opened', // conversationType: AI_SUPPORT | AGENT_CLIENT; source: placeholder | list | closed_thread
  CHAT_WIDGET_ATTACHMENT_SENT = 'chat_widget_attachment_sent', // conversationType; count; surface: new_conversation | thread; fileOnly
  CHAT_WIDGET_ATTACHMENT_REJECTED = 'chat_widget_attachment_rejected', // conversationType; reason: too_many | too_large | blocked_type | empty; count
  CHAT_WIDGET_ATTACHMENT_UPLOAD_FAILED = 'chat_widget_attachment_upload_failed', // conversationType; step: upload_urls | put | send; count
  CHAT_WIDGET_ASSISTANT_ANSWER_RATED = 'chat_widget_assistant_answer_rated',
  CHAT_WIDGET_ASSISTANT_ANSWER_THUMB_TAPPED = 'chat_widget_assistant_answer_thumb_tapped',
  // Marketing campaign tab (ISSUE-3637): fired through trackSocialCampaignEvent (utils/analytics/socialCampaign), which
  // types their properties. What the client asked and what the page got back; the facts the server records are its own.
  SOCIAL_CAMPAIGN_TAB_VIEWED = 'social_campaign_tab_viewed',
  SOCIAL_CAMPAIGN_GENERATION_STARTED = 'social_campaign_generation_started',
  SOCIAL_CAMPAIGN_GENERATION_FINISHED = 'social_campaign_generation_finished',
  SOCIAL_CAMPAIGN_PLAN_SAVED = 'social_campaign_plan_saved',
  SOCIAL_CAMPAIGN_CONTENT_KIND_SAVED = 'social_campaign_content_kind_saved',
  SOCIAL_CAMPAIGN_CONTENT_ADD_CHOSEN = 'social_campaign_content_add_chosen',
  SOCIAL_CAMPAIGN_SETTINGS_SAVED = 'social_campaign_settings_saved',
  SOCIAL_CAMPAIGN_EDITOR_OPENED = 'social_campaign_editor_opened',
  SOCIAL_CAMPAIGN_APPROVE_ALL_SUBMITTED = 'social_campaign_approve_all_submitted',
  SOCIAL_CAMPAIGN_GENERATE_SUBMITTED = 'social_campaign_generate_submitted',
  SOCIAL_CAMPAIGN_LIFECYCLE_SUBMITTED = 'social_campaign_lifecycle_submitted',
  SOCIAL_CAMPAIGN_POST_ACTION_SUBMITTED = 'social_campaign_post_action_submitted',
  SOCIAL_CAMPAIGN_TEXT_ACTION_SUBMITTED = 'social_campaign_text_action_submitted',
  SOCIAL_CAMPAIGN_TEXT_ACTION_FINISHED = 'social_campaign_text_action_finished',
}

export enum AIOptionsFlowType {
  GALLERY = 'gallery',
  PF = 'purchase-flow',
}
